import { Button, Grid, SimpleLayout, Text, useLayout } from '@approvalmax/ui/src/components';
import { actions } from 'modules/common';
import { hooks as pageHooks } from 'modules/page';
import { useDispatch } from 'modules/react-redux';
import { clearPersistStore } from 'modules/store';
import { useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { PasskeyAuthButton } from 'shared/components';

import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: false, hasDrawer: false });

    const dispatch = useDispatch();

    const authenticated = pageHooks.useProtectedAuth();

    const handleLogout = useCallback(() => dispatch(actions.logout(clearPersistStore)), [dispatch]);

    if (!authenticated) {
        return null;
    }

    return (
        <SimpleLayout size='medium'>
            <Helmet title={messages.title} />

            <SimpleLayout.Content>
                <Grid rowGap={16}>
                    <Text font='headline' fontSize='small' fontWeight='regular'>
                        {messages.description}
                    </Text>

                    <PasskeyAuthButton block outline noUppercase size='large' />

                    <Button onClick={handleLogout} color='blue10' size='large'>
                        {messages.logOut}
                    </Button>
                </Grid>
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
